import { Component, ElementRef, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { BusinessService } from "../business.service";
import { ToastrService } from "ngx-toastr";
import { CommonService } from "src/app/shareModule/services/common.service";
import { Location } from '@angular/common';

@Component({
  selector: "app-business-join-form",
  templateUrl: "./business-join-form.component.html",
  styleUrl: "./business-join-form.component.scss",
})
export class BusinessJoinFormComponent {
  businessForm!: FormGroup;
  imagePreview: string | ArrayBuffer | null = null;
  @ViewChild("fileInput") fileInput!: ElementRef;

  public selectedMemberRegionId = "";

  constructor(private location: Location,private fb: FormBuilder, private businessService: BusinessService, private toastr: ToastrService, private _commonService: CommonService) {}

  ngOnInit(): void {
    this.businessForm = this.fb.group({
      type: ["home"],
      companyName: ["", [Validators.required, Validators.minLength(3)]],
      contact: [""],
      address: ["", []],
      postalCode: [""],
      shortDescription: [""],
      image: [null],
      region: [""],
    });

    this.businessForm.get("region").disable();
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.businessForm.patchValue({ image: file });
      this.businessForm.get("image")?.updateValueAndValidity();

      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  onSubmit(): void {
    if (this.businessForm.valid) {
      let formData = new FormData();
      
      formData.append("type", this.businessForm.get("type").value);
      formData.append("companyName", this.businessForm.get("companyName").value);
      formData.append("contact", this.businessForm.get("contact").value);
      formData.append("address", this.businessForm.get("address").value);
      formData.append("postalCode", this.businessForm.get("postalCode").value);
      formData.append("shortDescription", this.businessForm.get("shortDescription").value);
      formData.append("image", this.businessForm.get("image").value);

      this.businessService.addJoinBiz(formData).subscribe((resp: any) => {
        this.toastr.success(resp?.message);
        this.businessForm.reset();
        this.imagePreview = null;
        this.fileInput.nativeElement.value = "";
      });
    } else {
      this.toastr.error("Form is invalid");
    }
  }

  public filterSubregions(value) {
    let region = this._commonService.getSubRegionBaseOnPostalCode(value) || "";
    this.businessForm.get("region").setValue(region ? region.name : "");
    this.selectedMemberRegionId = region ? region.subRegionId : "";
  }


  goBack(): void {
    this._commonService.goBack();
  }
}
